import { styled } from "~/common/mui";

export const ProductDetailsRoot = styled("div")(({ theme }) => ({
  "&__notifications, & .scha__pdp__notifications": {
    marginTop: theme.spacing(2),
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  "& .jsp__st4__left": {
    [theme.breakpoints.down("desktop-s")]: {
      display: "none",
    },
  },
  "& .scha__pdp__dmc-section": {
    marginBottom: theme.spacing(2),
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  "& .scha__pdp__manufacturer-logo": {
    width: 44,
  },
  "& .scha__pdp__brand-logo": {
    width: 60,
    marginTop: "auto",
  },
  "& .scha__pdp__short-description": {
    ...theme.typography.titleMedium,
    marginTop: theme.spacing(2),
    marginBottom: 0,
  },
  "& .scha__pdp__no-price": {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  "& .scha__pdp__price-header, & .scha__pdp__price-header--price-request": {
    ...theme.typography.headlineMedium,
    margin: 0,
  },
  "& .scha__pdp__price-header--price-request": {
    color: theme.palette.text.primary,
    fontWeight: "normal",
  },
  "& .scha__pdp-salesman__price-table-box": {
    padding: `${theme.spacing(1.25)} ${theme.spacing(2.5)}`,
    backgroundColor: theme.palette.surface.main,
    "& .scha__data-table__cell": {
      paddingLeft: theme.spacing(0.625),
      paddingRight: theme.spacing(0.625),
      wordBreak: "break-word",
      "&:first-child": {
        paddingLeft: 0,
      },
    },
  },
  "& .scha__pdp-salesman__target-price-box": {
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.surface.main,
  },
  "& .scha__pdp__specifications-card": {
    padding: theme.spacing(1.5),
    "& > * + *": {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.up("desktop-s")]: {
      padding: theme.spacing(3.75),
      "& > * + *": {
        marginTop: theme.spacing(5),
      },
    },
    "& .scha__product-variant-table .scha__table__title-as-header": {
      borderBottomWidth: 2,
    },
    "& .scha__product-variant-table table tr.MuiTableRow-root:nth-child(2n)": {
      background: "transparent",
    },
    "& .scha__product-variant-table table td": {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  },
  "& .scha__characteristics__title": {
    marginTop: 0,
    marginBottom: theme.spacing(1.5),
    ...theme.typography.titleMedium,
    [theme.breakpoints.up("desktop-s")]: {
      marginBottom: theme.spacing(2.5),
    },
  },
  "& .scha__characteristics__item-list": {
    display: "flex",
    flexWrap: "wrap",
    margin: theme.spacing(-0.75),
    "& > *": {
      margin: theme.spacing(0.75),
    },
  },
  "& .scha__characteristics__item__image": {
    width: 42,
    height: 42,
  },
  "& .scha__pdp__specifications-col": {
    [theme.breakpoints.down("desktop-s")]: {
      order: -1,
    },
  },
  "& .scha__pdp-iframe": {
    width: "100%",
    border: "none",
    [theme.breakpoints.down("desktop-s")]: {
      height: "100%",
    },
  },
  "& .scha__cad-iframe-container": {
    display: "flex",
    [theme.breakpoints.down("tablet")]: {
      aspectRatio: "1/1",
    },
    [theme.breakpoints.down("desktop-s")]: {
      padding: `0 ${theme.spacing(3)}`,
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.up("tablet")]: {
      height: 650,
    },
  },
  "& .scha__pdp__info-row": {
    [theme.breakpoints.down("desktop-s")]: {
      marginTop: theme.spacing(-4),
      "& > *": {
        marginTop: theme.spacing(4),
      },
    },
  },
  "& .scha__pdp__techdetails-col__table-list > * + *": {
    marginTop: theme.spacing(3),
    [theme.breakpoints.up("desktop-s")]: {
      marginTop: theme.spacing(3.75),
    },
  },
  "& .scha__pdp__footnotes__title": {
    marginTop: theme.spacing(3.75),
    marginBottom: theme.spacing(2.5),
    ...theme.typography.labelMedium,
  },
  "& .scha__pdp__footnotes__single-footnote": {
    color: theme.palette.text.secondary,
    display: "flex",
    marginBottom: theme.spacing(2.5),
    paddingTop: theme.spacing(0.25),
  },
  "& .scha__pdp__html-description": {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(5),
    "& > ul": {
      listStyleType: "disc",
    },
  },
  "& .scha__pdp__pdf-link, & .scha__pdp__download-title": {
    fontWeight: "normal",
    [theme.breakpoints.down("desktop-s")]: {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("desktop-s")]: {
      marginRight: theme.spacing(-1),
    },
  },
  "& .scha__pdp__long-description": {
    ...theme.typography.titleSmall,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("desktop-s")]: {
      marginBottom: theme.spacing(3),
    },
  },
  "& .scha__pdp__contact-us": {
    marginTop: theme.spacing(2),
  },
  "& .scha__grid-gapped-container .scha__param--vertical": {
    marginTop: theme.spacing(1.25),
  },
  "& .scha__pdp__tabs": {
    marginTop: theme.spacing(4),
  },
  "& .scha__pdp-mobile__product-image-container": {
    maxWidth: 318,
  },
  "& .scha__pdp-mobile__tech-image-container": {
    maxWidth: 460,
    maxHeight: "60vh",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing(1),
  },
  "& .scha__cad-iframe-download-tablet": {
    marginTop: `${theme.spacing(3.75)} !important`,
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  "& .scha__pdp__unitMode-msg": {
    marginTop: theme.spacing(2.5),
  },
  "& .scha__pdp__contact-sales-team": {
    marginTop: theme.spacing(1),
  },
  "& .scha__pdp__phase-out__successor__image, & .scha__pdp__phase-out__successor__package": {
    marginBottom: theme.spacing(4),
  },
  "& .scha__pdp__phase-out__successor__atc": {
    marginTop: theme.spacing(4),
  },
}));
